import Vue from "vue";
import "@/config/highcharts.js";
import "@/config/elementUi.js";
import i18n from "@/config/i18n";
import App from "./App.vue";
import router from "@/router";
import store from "./store/index";
import PortalVue from "portal-vue";
import VTooltip from "v-tooltip";
import { cloneDeep, get, result, capitalize } from "lodash";
import moment from "moment";
import commonUtils from "./utils/commonUtils";
import "@/components/base/globalComponentRegistration";
import "@/layouts/globalComponentRegistration";
import table from "@/constants/table";
import deviceTypes from "@/constants/deviceTypes";
import userAccessManagementMixin from "@/mixins/userAccessManagementMixin";
import documentTitleMixin from "@/mixins/documentTitleMixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

// global mixins space
Vue.mixin(userAccessManagementMixin);
Vue.mixin(documentTitleMixin);
// global plugins space
Vue.use(PortalVue);
Vue.use(VTooltip);

// global filters space
Vue.filter("commas", function(value, countryCode) {
  if (!value) {
    return value;
  }
  return parseInt(value).toLocaleString(`en-${countryCode}`);
});

// global variables space
Vue.config.productionTip = false;
Vue.prototype.$lodash = { cloneDeep, get, result, capitalize };
Vue.prototype.$moment = moment;
Vue.prototype.$constants = { table, deviceTypes };
Vue.prototype.$commonUtils = commonUtils;
const vueObj = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
});

vueObj.$mount("#app");
